module.exports = __webpack_public_path__ + "static/media/sence_floor.66a7f7ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/GameTheme/Background/sence_floor.png
// module id = 278
// module chunks = 0